module.exports = __webpack_public_path__ + "assets/img/sam.b66f9bb7.jpg";